import { all, put, fork, takeEvery, select, delay, call } from 'redux-saga/effects';
import actions from './actions';
import { post, get, PUT } from '@iso/lib/helpers/resApiRequestor';
import accountOfficerAction from '@iso/redux/account_officer/actions';
import merchantActions from '@iso/redux/merchant/actions';
import settlementActions from '@iso/redux/settlement/actions';
// START: MERCHANT PORTAL
export function* fetchAllMerchantPortal() {
  yield takeEvery('FETCH_ALL_MERCHANT_PORTAL', function* ({ payload, currentList }) {
    try {
      if (payload && payload.loadMore) {
        yield put({
          type: actions.LOADING_MORE_MERCHANT_PORTAL,
          loading: true
        });
      } else {
        yield put({
          type: actions.FETCHING_ALL_MERCHANT_PORTAL,
          loading: true
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllMerchantPortalAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      const listData = currentList && payload.loadMore && currentList.length > 0 ? currentList : [];
      const parseData =
        listData && listData.length > 0 ? listData.concat(result.data) : result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_MERCHANT_PORTAL_SUCCESS,
          loading: false,
          result: parseData,
          pagination: result.pagination,
          filter: {
            ...payload
          }
        });

        if (parseData.length > 0 && parseData[0] && parseData[0].id) {
          yield put({
            type: actions.FETCH_MERCHANT_PORTAL_BY_ID,
            payload: parseData[0].id
          });
          yield put({
            type: accountOfficerAction.FETCH_MIS_DATA_BY_ID,
            payload: parseData[0].id
          });
          yield put({
            type: actions.FETCH_MERCHANT_KYB_DOCUMENT_BY_ID,
            payload: { id: parseData[0].id }
          });
          yield put({
            type: actions.FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID,
            payload: { id: parseData[0].id }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_ALL_MERCHANT_PORTAL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_MERCHANT_PORTAL_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_MERCHANT_PORTAL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchMerchantKYBDocuments() {
  yield takeEvery('FETCH_MERCHANT_KYB_DOCUMENT_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_KYB_DOCUMENT_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantKYBDocumentsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_KYB_DOCUMENT_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null,
          pagination: result && result.pagination ? result.pagination : null,
          expiry_config: result && result.expiry_config ? result.expiry_config : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_KYB_DOCUMENT_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_KYB_DOCUMENT_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchMerchantKaiserCheckResults() {
  yield takeEvery('FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_KAISER_CHECK_RESULTS_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantKaiserCheckResultsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null,
          pagination: result && result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAmendHistoryMOC() {
  yield takeEvery('FETCH_AMEND_HISTORY_MOC', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_AMEND_HISTORY_MOC,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAmendHistoryMOCAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_AMEND_HISTORY_MOC_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_AMEND_HISTORY_MOC_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_AMEND_HISTORY_MOC_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadKYBDocument() {
  yield takeEvery('DOWNLOAD_MERCHANT_KYB_DOCUMENT', function* ({ id, payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_MERCHANT_KYB_DOCUMENT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadKYBDocumentAPI(id, payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_MERCHANT_KYB_DOCUMENT_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_MERCHANT_KYB_DOCUMENT_FAILED,
            message: `Endpoint not found`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_MERCHANT_KYB_DOCUMENT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_MERCHANT_KYB_DOCUMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadKaiserCheckResults() {
  yield takeEvery('DOWNLOAD_MERCHANT_KAISER_CHECK_RESULTS', function* ({ id, payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_MERCHANT_KAISER_CHECK_RESULTS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadKaiserCheckResultsAPI(id, payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_MERCHANT_KAISER_CHECK_RESULTS_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_MERCHANT_KAISER_CHECK_RESULTS_FAILED,
            message: `Endpoint not found`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_MERCHANT_KAISER_CHECK_RESULTS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_MERCHANT_KAISER_CHECK_RESULTS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadSettlementDocument() {
  yield takeEvery('DOWNLOAD_MERCHANT_SETTLEMENT_DOCUMENT', function* ({ id, payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_MERCHANT_SETTLEMENT_DOCUMENT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadSettlementDocumentAPI(id, payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_MERCHANT_SETTLEMENT_DOCUMENT_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_MERCHANT_SETTLEMENT_DOCUMENT_FAILED,
            message: `Endpoint not found`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_MERCHANT_SETTLEMENT_DOCUMENT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_MERCHANT_SETTLEMENT_DOCUMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadAddendumDocument() {
  yield takeEvery('DOWNLOAD_ADDENDUM_DOCUMENT_ONBOARDING', function* ({ id, payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_ADDENDUM_DOCUMENT_ONBOARDING,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadAddendumDocumentAPI(id, payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_ADDENDUM_DOCUMENT_ONBOARDING_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_ADDENDUM_DOCUMENT_ONBOARDING_FAILED,
            message: `Endpoint not found`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_ADDENDUM_DOCUMENT_ONBOARDING_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_ADDENDUM_DOCUMENT_ONBOARDING_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* merchantDownloadKYBDocument() {
  yield takeEvery('MERCHANT_DOWNLOAD_KYB_DOCUMENT', function* ({ id }) {
    try {
      yield put({
        type: actions.MERCHANT_DOWNLOADING_KYB_DOCUMENT,
        loading: true
      });
      const apiResult = yield merchantDownloadKYBDocumentAPI(id);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.MERCHANT_DOWNLOAD_KYB_DOCUMENT_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.MERCHANT_DOWNLOAD_KYB_DOCUMENT_FAILED,
            message: `Endpoint not found`,
            loading: false
          });
        } else {
          yield put({
            type: actions.MERCHANT_DOWNLOAD_KYB_DOCUMENT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.MERCHANT_DOWNLOAD_KYB_DOCUMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* changeDocumentStatus() {
  yield takeEvery('EDIT_KYB_DOCUMENT_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_KYB_DOCUMENT_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const state = yield select();
      const currentFilter = state.Onboarding.merchantKYBDocumentFilter;
      const apiResult = yield changeDocumentStatusAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_KYB_DOCUMENT_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        if (currentFilter) {
          yield put({
            type: actions.FETCH_MERCHANT_KYB_DOCUMENT_BY_ID,
            payload: currentFilter
          });
          yield put({
            type: actions.FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID,
            payload: currentFilter
          });
          if (payload && payload.merchant_id) {
            yield put({
              type: actions.FETCH_MERCHANT_ONBOARDING_LOGS,
              payload: payload.merchant_id,
              pagination: {
                page: 0,
                limit: 20
              }
            });
          }
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_KYB_DOCUMENT_DATA_FAILED,
            message: `Endpoint not found`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_KYB_DOCUMENT_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_KYB_DOCUMENT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchMerchantPortalByID() {
  yield takeEvery('FETCH_MERCHANT_PORTAL_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_PORTAL_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantPortalByIDAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_PORTAL_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });

        if (result.data && result.data.id) {
          yield put({
            type: actions.FETCH_ACCOUNT_HISTORY,
            payload: result.data.id,
            pagination: {
              page: 0,
              limit: 20
            }
          });
          yield put({
            type: actions.FETCH_REPORT_HISTORY,
            payload: result.data.id,
            pagination: {
              page: 0,
              limit: 20
            }
          });
        }
        yield put({
          type: actions.FETCH_MERCHANT_ONBOARDING_LOGS,
          payload: payload,
          pagination: {
            page: 0,
            limit: 20
          }
        });
        yield put({
          type: actions.FETCH_MERCHANT_SETTLEMENT_LOGS,
          payload: payload,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_PORTAL_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_PORTAL_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchMerchantOnboardingLogs() {
  yield takeEvery('FETCH_MERCHANT_ONBOARDING_LOGS', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_MERCHANT_ONBOARDING_LOGS
        });
      } else {
        yield put({
          type: actions.FETCHING_MERCHANT_ONBOARDING_LOGS,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantOnboardingLogsAPI(payload, pagination, roleHeaderAuth);
      const currentList = pagination.currentData && loadmore ? pagination.currentData : [];

      const result = apiResult.data;

      const parseData =
        currentList && currentList.length > 0
          ? currentList.concat(result.data.logs)
          : result.data.logs;

      const finalData =
        parseData && parseData.length > 0
          ? parseData.sort((a, b) => {
              const dateA = new Date(a.created_at);
              const dateB = new Date(b.created_at);
              return dateB - dateA;
            })
          : [];

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_ONBOARDING_LOGS_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.data.pagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_ONBOARDING_LOGS_FAILED,
          loading: false,
          payload: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_ONBOARDING_LOGS_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}

export function* fetchMerchantOnboardingDashboardLogs() {
  yield takeEvery('FETCH_MERCHANT_ONBOARDING_DASHBOARD_LOGS', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_MERCHANT_ONBOARDING_DASHBOARD_LOGS
        });
      } else {
        yield put({
          type: actions.FETCHING_MERCHANT_ONBOARDING_DASHBOARD_LOGS,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantOnboardingLogsAPI(payload, pagination, roleHeaderAuth);
      const currentList = pagination.currentData && loadmore ? pagination.currentData : [];

      const result = apiResult.data;

      const parseData =
        currentList && currentList.length > 0
          ? currentList.concat(result.data.logs)
          : result.data.logs;

      const finalData =
        parseData && parseData.length > 0
          ? parseData.sort((a, b) => {
              const dateA = new Date(a.created_at);
              const dateB = new Date(b.created_at);
              return dateB - dateA;
            })
          : [];

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_ONBOARDING_DASHBOARD_LOGS_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.data.pagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_ONBOARDING_DASHBOARD_LOGS_FAILED,
          loading: false,
          payload: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_ONBOARDING_DASHBOARD_LOGS_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}

export function* fetchSettlementOnboardingLogs() {
  yield takeEvery('FETCH_MERCHANT_SETTLEMENT_LOGS', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_MERCHANT_SETTLEMENT_LOGS
        });
      } else {
        yield put({
          type: actions.FETCHING_MERCHANT_SETTLEMENT_LOGS,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantSettlementLogsAPI(payload, pagination, roleHeaderAuth);
      const currentList = pagination.currentData && loadmore ? pagination.currentData : [];

      const result = apiResult.data;

      const parseData =
        currentList && currentList.length > 0
          ? currentList.concat(result.data.logs)
          : result.data.logs;

      const finalData =
        parseData && parseData.length > 0
          ? parseData.sort((a, b) => {
              const dateA = new Date(a.created_at);
              const dateB = new Date(b.created_at);
              return dateB - dateA;
            })
          : [];

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_SETTLEMENT_LOGS_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.data.pagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_SETTLEMENT_LOGS_FAILED,
          loading: false,
          payload: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_SETTLEMENT_LOGS_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}

export function* fetchAccountHistory() {
  yield takeEvery('FETCH_ACCOUNT_HISTORY', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_ACCOUNT_HISTORY
        });
      } else {
        yield put({
          type: actions.FETCHING_ACCOUNT_HISTORY,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAccountHistoryAPI(payload, pagination, roleHeaderAuth);
      const currentList = pagination.currentData && loadmore ? pagination.currentData : [];

      const result = apiResult.data;

      const parseData =
        currentList && currentList.length > 0
          ? currentList.concat(result.data.logs)
          : result.data.logs;

      const finalData =
        parseData && parseData.length > 0
          ? parseData.sort((a, b) => {
              const dateA = new Date(a.created_at);
              const dateB = new Date(b.created_at);
              return dateB - dateA;
            })
          : [];

      if (result.success) {
        yield put({
          type: actions.FETCH_ACCOUNT_HISTORY_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.data.pagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_ACCOUNT_HISTORY_FAILED,
          loading: false,
          payload: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ACCOUNT_HISTORY_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}

export function* fetchReportHistory() {
  yield takeEvery('FETCH_REPORT_HISTORY', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_REPORT_HISTORY
        });
      } else {
        yield put({
          type: actions.FETCHING_REPORT_HISTORY,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchReportHistoryAPI(payload, pagination, roleHeaderAuth);
      const currentList = pagination.currentData && loadmore ? pagination.currentData : [];

      const result = apiResult.data;

      const parseData =
        currentList && currentList.length > 0
          ? currentList.concat(result.data.logs)
          : result.data.logs;

      const finalData =
        parseData && parseData.length > 0
          ? parseData.sort((a, b) => {
              const dateA = new Date(a.created_at);
              const dateB = new Date(b.created_at);
              return dateB - dateA;
            })
          : [];

      if (result.success) {
        yield put({
          type: actions.FETCH_REPORT_HISTORY_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.data.pagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_REPORT_HISTORY_FAILED,
          loading: false,
          payload: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_REPORT_HISTORY_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}

export function* fetchOnboardingLogs() {
  yield takeEvery('FETCH_ONBOARDING_LOGS', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_ONBOARDING_LOGS
        });
      } else {
        yield put({
          type: actions.FETCHING_ONBOARDING_LOGS,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchOnboardingLogsAPI(payload, pagination, roleHeaderAuth);
      const currentList = pagination.currentData && loadmore ? pagination.currentData : [];

      const result = apiResult.data;

      const parseData =
        currentList && currentList.length > 0
          ? currentList.concat(result.data.logs)
          : result.data.logs;

      const finalData =
        parseData && parseData.length > 0
          ? parseData.sort((a, b) => {
              const dateA = new Date(a.created_at);
              const dateB = new Date(b.created_at);
              return dateB - dateA;
            })
          : [];

      if (result.success) {
        yield put({
          type: actions.FETCH_ONBOARDING_LOGS_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.data.pagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_ONBOARDING_LOGS_FAILED,
          loading: false,
          payload: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ONBOARDING_LOGS_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}

// Start: KYB
export function* generateKYBForm() {
  yield takeEvery('GENERATE_KYB_FORM', function* ({ id, payload }) {
    try {
      yield put({
        type: actions.GENERATING_KYB_FORM,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateKYBFormAPI(id, payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.GENERATE_KYB_FORM_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });

        yield put({
          type: actions.FETCH_ALL_MERCHANT_PORTAL,
          payload: {
            page: 0,
            limit: 20
          },
          currentList: null
        });
        yield commonFetchRequests(id);
      } else {
        yield put({
          type: actions.GENERATE_KYB_FORM_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_KYB_FORM_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* resendKYBForm() {
  yield takeEvery(actions.RESEND_KYB_FORM, function* ({ payload }) {
    try {
      yield put({
        type: actions.RESENDING_KYB_FORM,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield resendKYBFormAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.RESEND_KYB_FORM_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });

        yield put({
          type: actions.FETCH_ALL_MERCHANT_PORTAL,
          payload: {
            page: 0,
            limit: 20
          },
          currentList: null
        });

        const id = payload?.merchant_management;
        if (id) {
          yield commonFetchRequests(id);
        }
      } else {
        yield put({
          type: actions.RESEND_KYB_FORM_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.RESEND_KYB_FORM_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* regenerateKYBForm() {
  yield takeEvery('REGENERATE_KYB_FORM', function* ({ payload }) {
    try {
      yield put({
        type: actions.REGENERATING_KYB_FORM,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield regenerateKYBFormAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REGENERATE_KYB_FORM_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
        yield put({
          type: actions.FETCH_ALL_GENERATED_KYB_FORMS,
          payload: {
            pagination: {
              page: 0,
              limit: 20
            }
          }
        });
      } else {
        yield put({
          type: actions.REGENERATE_KYB_FORM_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.REGENERATE_KYB_FORM_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllGeneratedKYBForms() {
  yield takeEvery('FETCH_ALL_GENERATED_KYB_FORMS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_ALL_GENERATED_KYB_FORMS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllGenratedKYBFormsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_GENERATED_KYB_FORMS_SUCCESS,
          loading: false,
          result: result ? result.data : null,
          pagination: result ? result.pagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_ALL_GENERATED_KYB_FORMS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_GENERATED_KYB_FORMS_FAILED,
        loading: false
      });
    }
  });
}

// END: KYB

// END: MERCHANT PORTAL

// START: VAT EXEMPTION
export function* getS3UrlsVATExemptionFile() {
  yield takeEvery('STORE_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT', function* ({ payload }) {
    try {
      yield put({
        type: actions.STORING_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT,
        loading: true
      });
      const state = yield select();
      const presignedUrlsVAT_EXEMPTION = state.Onboarding.presignedUrlsVAT_EXEMPTION;

      const roleHeaderAuth = null;
      const apiResult = yield getURLsForMerchantFilesAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (presignedUrlsVAT_EXEMPTION && presignedUrlsVAT_EXEMPTION.length > 0) {
          urlsArr.push(...presignedUrlsVAT_EXEMPTION);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_VAT_EXEMPTION_FOR_UPLOAD_MERCHANT_FAILED,
        loading: false
      });
    }
  });
}
// END: VAT EXEMPTION

// START: KYB FORM
export function* getS3UrlsSECFile() {
  yield takeEvery('STORE_SEC_FOR_UPLOAD', function* ({ payload }) {
    try {
      yield put({
        type: actions.STORING_SEC_FOR_UPLOAD,
        loading: true
      });
      const state = yield select();
      const presignedUrlsSEC = state.Onboarding.presignedUrlsSEC;

      const roleHeaderAuth = null;
      const apiResult = yield getURLsForMerchantFilesAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (presignedUrlsSEC && presignedUrlsSEC.length > 0) {
          urlsArr.push(...presignedUrlsSEC);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_SEC_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_SEC_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_SEC_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}
export function* getS3UrlsAOIFile() {
  yield takeEvery('STORE_AOI_FOR_UPLOAD', function* ({ payload }) {
    try {
      yield put({
        type: actions.STORING_AOI_FOR_UPLOAD,
        loading: true
      });
      const state = yield select();
      const presignedUrlsAOI = state.Onboarding.presignedUrlsAOI;

      const roleHeaderAuth = null;
      const apiResult = yield getURLsForMerchantFilesAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (presignedUrlsAOI && presignedUrlsAOI.length > 0) {
          urlsArr.push(...presignedUrlsAOI);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_AOI_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_AOI_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_AOI_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}
export function* getS3UrlBIR2303File() {
  yield takeEvery(actions.STORE_BIR_2303_FOR_UPLOAD, function* ({ fileName, bucketKey }) {
    try {
      yield put({
        type: actions.STORING_BIR_2303_FOR_UPLOAD,
        loading: true
      });

      const apiResult = yield getURLForFileAPI(fileName, bucketKey);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.STORE_BIR_2303_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: result?.data
        });
      } else {
        yield put({
          type: actions.STORE_BIR_2303_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_BIR_2303_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* getS3UrlDTICertificateFile() {
  yield takeEvery(actions.STORE_DTI_CERTIFICATE_FOR_UPLOAD, function* ({ fileName, bucketKey }) {
    try {
      yield put({
        type: actions.STORING_DTI_CERTIFICATE_FOR_UPLOAD,
        loading: true
      });

      const apiResult = yield getURLForFileAPI(fileName, bucketKey);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.STORE_DTI_CERTIFICATE_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: result?.data
        });
      } else {
        yield put({
          type: actions.STORE_DTI_CERTIFICATE_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_DTI_CERTIFICATE_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}
export function* getS3UrlsGISFile() {
  yield takeEvery('STORE_GIS_FOR_UPLOAD', function* ({ payload }) {
    try {
      yield put({
        type: actions.STORING_GIS_FOR_UPLOAD,
        loading: true
      });
      const state = yield select();
      const presignedUrlsGIS = state.Onboarding.presignedUrlsGIS;

      const roleHeaderAuth = null;
      const apiResult = yield getURLsForMerchantFilesAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (presignedUrlsGIS && presignedUrlsGIS.length > 0) {
          urlsArr.push(...presignedUrlsGIS);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_GIS_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_GIS_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_GIS_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* uploadKYBFiles() {
  yield takeEvery('UPLOAD_KYB_FILES', function* ({ urls, payload, id }) {
    try {
      yield put({
        type: actions.UPLOADING_KYB_FILES,
        loading: true
      });

      if (!payload?.required_files || !urls) {
        throw new Error('No files or URLs provided');
      }

      const dataFiles = payload.required_files;

      // Prepare upload tasks
      const uploadTasks = dataFiles
        .map(file => {
          if (Object.hasOwn(file, 'document_type') && Object.hasOwn(file, 'name')) {
            const getUrl = urls.required_files[file.document_type];
            if (getUrl) {
              return call(uploadFileToS3WithPromise, getUrl, file);
            }
          }
          return null; // skip invalid entries
        })
        .filter(Boolean);

      // Wait for all uploads to complete
      yield all(uploadTasks);

      // If all succeed, build requiredFilesData
      const requiredFilesData = dataFiles
        .filter(file => urls.required_files[file.document_type])
        .map(file => ({
          name: file.name,
          code: file.document_type,
          file_type: file.file_type
        }));

      // Call backend API with uploaded files info
      const apiResult = yield call(
        uploadKYBFilesAPI,
        {
          ...payload,
          required_files: requiredFilesData
        },
        id,
        null
      );

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.UPLOAD_KYB_FILES_SUCCESS,
          loading: false,
          message: result.message
        });

        // Refresh merchant KYB details
        yield put({
          type: merchantActions.FETCH_MIS_MERCHANT_DETAILS,
          payload: id
        });
      } else {
        yield put({
          type: actions.UPLOAD_KYB_FILES_FAILED,
          message: result.status === 404 ? `Endpoint ${result.title}` : result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.UPLOAD_KYB_FILES_FAILED,
        message: `Couldn't upload files. Check your connection, refresh the page, and try again.`,
        loading: false
      });
    }
  });
}

export function* uploadKYBLinkFiles() {
  yield takeEvery(actions.UPLOAD_KYB_LINK_FILES, function* ({ urls, payload, id }) {
    try {
      yield put({
        type: actions.UPLOADING_KYB_LINK_FILES,
        loading: true
      });

      let dtiData = null;
      let birData = null;
      if (
        payload?.dti_certificate_file &&
        urls?.dti_certificate_file?.includes(payload.dti_certificate_file.name)
      ) {
        yield uploadFileToS3(urls?.dti_certificate_file, payload?.dti_certificate_file);
        dtiData = {
          name: payload?.dti_certificate_file?.name,
          file_type: payload?.dti_certificate_file?.file_type
        };
      }
      if (payload?.bir_2303_file && urls?.bir_2303_file?.includes(payload.bir_2303_file.name)) {
        yield uploadFileToS3(urls?.bir_2303_file, payload?.bir_2303_file);
        birData = {
          name: payload?.bir_2303_file?.name,
          file_type: payload?.bir_2303_file?.file_type
        };
      }
      if (dtiData === null && birData === null) {
        throw new Error('DTI and BIR  must be uploaded.');
      }

      const apiResult = yield uploadKYBLinkFilesAPI(
        {
          ...payload,
          dti_data: dtiData,
          bir_data: birData
        },
        id,
        null
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPLOAD_KYB_LINK_FILES_SUCCESS,
          loading: false,
          message: result.message
        });
        // Fetch KYB Form for merchant
        // yield put({
        //   type: merchantActions.FETCH_MIS_MERCHANT_DETAILS,
        //   payload: id
        // });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPLOAD_KYB_LINK_FILES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPLOAD_KYB_LINK_FILES_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPLOAD_KYB_LINK_FILES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* uploadVATExemptionFiles() {
  yield takeEvery('UPLOAD_VAT_EXEMPTION_FILES', function* ({ urls, payload, id }) {
    try {
      yield put({
        type: actions.UPLOADING_VAT_EXEMPTION_FILES,
        loading: true
      });

      let vatExemptionData = [];
      if (
        payload &&
        payload.vat_exemption_files &&
        payload.vat_exemption_files.length === urls.vat_exemption_files.length
      ) {
        const dataFile = payload.vat_exemption_files;
        dataFile.forEach(file => {
          if (urls.vat_exemption_files.some(str => str.includes(file.name))) {
            let getURL = urls.vat_exemption_files.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              vatExemptionData.push(currentObj);
            }
          }
        });
      }
      const vat_exemptionLength = (urls?.vat_exemption_files ?? []).length;

      yield delay(vat_exemptionLength * 1000);

      const apiResult = yield uploadVATExemptionFilesAPI(
        {
          ...payload,
          vat_exemption_files: vatExemptionData
        },
        id,
        null
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPLOAD_VAT_EXEMPTION_FILES_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: merchantActions.FETCH_MIS_MERCHANT_DETAILS,
          payload: id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPLOAD_VAT_EXEMPTION_FILES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPLOAD_VAT_EXEMPTION_FILES_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPLOAD_VAT_EXEMPTION_FILES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* uploadKYBFilesByMO() {
  yield takeEvery('UPLOAD_KYB_FILES_BY_MO', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.UPLOADING_KYB_FILES_BY_MO,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      let requiredFilesData = [];

      if (payload && payload.required_files && urls) {
        const dataFiles = payload.required_files;
        dataFiles.forEach(file => {
          if (Object.hasOwn(file, 'document_type') && Object.hasOwn(file, 'name')) {
            let getUrl = urls?.required_files[file.document_type];
            if (getUrl) {
              uploadFileToS3(getUrl, file);
              let currentObj = {
                name: file.name,
                code: file.document_type,
                file_type: file.file_type
              };
              requiredFilesData.push(currentObj);
            }
          }
        });
      }

      yield delay(requiredFilesData.length * 1000);

      const apiResult = yield uploadKYBFilesByMOAPI(
        {
          ...payload,
          required_files: requiredFilesData
        },
        roleHeaderAuth
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPLOAD_KYB_FILES_BY_MO_SUCCESS,
          loading: false,
          message: result.message
        });

        if (payload?.merchant_management_id) {
          const merchantManagementId = payload?.merchant_management_id;
          yield commonFetchRequests(merchantManagementId);
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPLOAD_KYB_FILES_BY_MO_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPLOAD_KYB_FILES_BY_MO_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPLOAD_KYB_FILES_BY_MO_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchKYBFormMerchantDetails() {
  yield takeEvery('FETCH_KYB_FORM_MERCHANT_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_KYB_FORM_MERCHANT_DATA,
        loading: true
      });

      const apiResult = yield fetchKYBFormMerchantDataAPI(payload);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_KYB_FORM_MERCHANT_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_KYB_FORM_MERCHANT_DATA_FAILED,
          loading: false,
          result: []
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_KYB_FORM_MERCHANT_DATA_FAILED,
        payload: [],
        loading: false
      });
    }
  });
}

export function* getS3UrlsForRequiredFiles() {
  yield takeEvery('STORE_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD', function* ({ payload }) {
    try {
      yield put({
        type: actions.STORING_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD,
        loading: true
      });
      const state = yield select();
      const presignedUrlsForRequiredFiles = state?.Onboarding.presignedUrlsForRequiredFiles ?? {};

      const roleHeaderAuth = null;
      const apiResult = yield getURLsForMerchantFilesAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const newResult = {
          ...presignedUrlsForRequiredFiles,
          [payload.document_type]: result.data[0]
        };

        yield put({
          type: actions.STORE_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: newResult
        });
      } else {
        yield put({
          type: actions.STORE_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_DYNAMIC_REQUIRED_FILES_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

// END: KYB FORM

export function* fetchAllOnboardingUsers() {
  yield takeEvery('FETCH_ALL_ONBOARDING_USERS', function* () {
    try {
      yield put({
        type: actions.FETCHING_ALL_ONBOARDING_USERS,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllOnboardingUsersAPI(roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_ONBOARDING_USERS_SUCCESS,
          loading: false,
          result: result.data
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_ALL_ONBOARDING_USERS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_ONBOARDING_USERS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_ONBOARDING_USERS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* assignMerchantOnboarding() {
  yield takeEvery('ASSIGN_MERCHANT_ONBOARDING', function* ({ payload }) {
    try {
      yield put({
        type: actions.ASSIGNING_MERCHANT_ONBOARDING,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield assignMerchantOnboardingAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ASSIGN_MERCHANT_ONBOARDING_SUCCESS,
          loading: false,
          message: result.message
        });

        yield commonFetchRequests(payload.merchant_mgmt_id);
      } else {
        yield put({
          type: actions.ASSIGN_MERCHANT_ONBOARDING_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.ASSIGN_MERCHANT_ONBOARDING_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* generateMerchantOnboardingStatusReport() {
  yield takeEvery('GENERATE_MERCHANT_ONBOARDING_STATUS_REPORT', function* ({ payload }) {
    try {
      yield put({
        type: actions.GENERATING_MERCHANT_ONBOARDING_STATUS_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateMerchantOnboardingStatusReportAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.GENERATE_MERCHANT_ONBOARDING_STATUS_REPORT_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA,
          payload: {
            pagination: {
              page: 0,
              limit: 20
            }
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.GENERATE_MERCHANT_ONBOARDING_STATUS_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.GENERATE_MERCHANT_ONBOARDING_STATUS_REPORT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_MERCHANT_ONBOARDING_STATUS_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadMerchantOnboardingStatusReport() {
  yield takeEvery('DOWNLOAD_MERCHANT_ONBOARDING_STATUS_REPORT', function* ({ id }) {
    try {
      yield put({
        type: actions.DOWNLOADING_MERCHANT_ONBOARDING_STATUS_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadMerchantOnboardingSettlementReportAPI(id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_MERCHANT_ONBOARDING_STATUS_REPORT_SUCCESS,
          loading: false,
          message: 'Merchant onboarding status report downloaded successfully.'
        });

        if (result.url) {
          window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_MERCHANT_ONBOARDING_STATUS_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_MERCHANT_ONBOARDING_STATUS_REPORT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_MERCHANT_ONBOARDING_STATUS_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllMerchantOnboardingStatusReportData() {
  yield takeEvery(
    'FETCH_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA',
    function* ({ payload }) {
      try {
        yield put({
          type: actions.FETCHING_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA,
          loading: true
        });
        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield fetchAllMerchantOnboardingStatusReportDataAPI(
          payload,
          roleHeaderAuth
        );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.FETCH_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA_SUCCESS,
            loading: false,
            result: result ? result.data : null,
            pagination: result ? result.pagination : null
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA_FAILED,
            loading: false
          });
        }
      } catch (error) {
        yield put({
          type: actions.FETCH_ALL_MERCHANT_ONBOARDING_STATUS_REPORT_DATA_FAILED,
          loading: false
        });
      }
    }
  );
}

export function* requestMISAmendment() {
  yield takeEvery('REQUEST_MIS_AMENDMENT', function* ({ payload }) {
    try {
      yield put({
        type: actions.REQUESTING_MIS_AMENDMENT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield requestMISAmendmentAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REQUEST_MIS_AMENDMENT_SUCCESS,
          loading: false,
          message: result.message
        });

        yield commonFetchRequests(payload.merchant_mgmt_id);
      } else {
        yield put({
          type: actions.REQUEST_MIS_AMENDMENT_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.REQUEST_MIS_AMENDMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* approveMISAmendment() {
  yield takeEvery('APPROVE_MIS_AMENDMENT', function* ({ payload }) {
    try {
      yield put({
        type: actions.APPROVING_MIS_AMENDMENT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield approveMISAmendmentAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.APPROVE_MIS_AMENDMENT_SUCCESS,
          loading: false,
          message: result.message
        });

        yield commonFetchRequests(payload.merchant_mgmt_id);
        yield put({
          type: actions.FETCH_MERCHANT_KYB_DOCUMENT_BY_ID,
          payload: { id: payload.merchant_mgmt_id }
        });
        yield put({
          type: actions.FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID,
          payload: { id: payload.merchant_mgmt_id }
        });
      } else {
        yield put({
          type: actions.APPROVE_MIS_AMENDMENT_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.APPROVE_MIS_AMENDMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* endorseMISAmendment() {
  yield takeEvery('ENDORSE_MIS_AMENDMENT', function* ({ payload }) {
    try {
      yield put({
        type: actions.ENDORSING_MIS_AMENDMENT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield endorseMISAmendmentAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ENDORSE_MIS_AMENDMENT_SUCCESS,
          loading: false,
          message: result.message
        });

        yield commonFetchRequests(payload.merchant_mgmt_id);
      } else {
        yield put({
          type: actions.ENDORSE_MIS_AMENDMENT_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.ENDORSE_MIS_AMENDMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* rejectMISAmendment() {
  yield takeEvery('REJECT_MIS_AMENDMENT', function* ({ payload }) {
    try {
      yield put({
        type: actions.REJECTING_MIS_AMENDMENT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield rejectMISAmendmentAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REJECT_MIS_AMENDMENT_SUCCESS,
          loading: false,
          message: result.message
        });

        yield commonFetchRequests(payload.merchant_mgmt_id);
      } else {
        yield put({
          type: actions.REJECT_MIS_AMENDMENT_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.REJECT_MIS_AMENDMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* approveSettlementReport() {
  yield takeEvery('APPROVE_SETTLEMENT_REPORT', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.APPROVING_SETTLEMENT_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let eSignature = [];
      if (
        payload &&
        payload.e_signature &&
        urls &&
        urls.e_signature &&
        payload.e_signature.length === urls.e_signature.length
      ) {
        const dataFile = payload.e_signature;
        dataFile.forEach(file => {
          if (urls.e_signature.some(str => str.includes(file.name))) {
            let getURL = urls.e_signature.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              eSignature.push(currentObj);
            }
          }
        });

        yield delay(urls.e_signature.length * 1000);
      }

      const apiResult = yield approveSettlementReportAPI(
        { ...payload, e_signature: eSignature },
        roleHeaderAuth
      );

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.APPROVE_SETTLEMENT_REPORT_SUCCESS,
          loading: false,
          message: result.message
        });

        // yield commonFetchRequests(payload.merchant_id);
        yield put({
          type: settlementActions.FETCH_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID,
          payload: payload.merchant_settlement_cycle_id
        });
        yield put({
          type: settlementActions.FETCH_SETTLEMENT_REPORT_HISTORY,
          payload: payload.merchant_settlement_cycle_id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
        yield put({
          type: actions.FETCH_MERCHANT_KYB_DOCUMENT_BY_ID,
          payload: { id: payload.merchant_mgmt_id }
        });
      } else {
        yield put({
          type: actions.APPROVE_SETTLEMENT_REPORT_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.APPROVE_SETTLEMENT_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* reviewSettlementReport() {
  yield takeEvery('REVIEW_SETTLEMENT_REPORT', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.ENDORSING_SETTLEMENT_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let eSignature = [];
      if (
        payload &&
        payload.e_signature &&
        urls &&
        urls.e_signature &&
        payload.e_signature.length === urls.e_signature.length
      ) {
        const dataFile = payload.e_signature;
        dataFile.forEach(file => {
          if (urls.e_signature.some(str => str.includes(file.name))) {
            let getURL = urls.e_signature.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              eSignature.push(currentObj);
            }
          }
        });

        yield delay(urls.e_signature.length * 1000);
      }

      const apiResult = yield reviewSettlementReportAPI(
        { ...payload, e_signature: eSignature },
        roleHeaderAuth
      );

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REVIEW_SETTLEMENT_REPORT_SUCCESS,
          loading: false,
          message: result.message
        });

        // yield commonFetchRequests(payload.merchant_id);
        yield put({
          type: settlementActions.FETCH_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID,
          payload: payload.merchant_settlement_cycle_id
        });
        yield put({
          type: settlementActions.FETCH_SETTLEMENT_REPORT_HISTORY,
          payload: payload.merchant_settlement_cycle_id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        yield put({
          type: actions.REVIEW_SETTLEMENT_REPORT_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.REVIEW_SETTLEMENT_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* endorseSettlementReport() {
  yield takeEvery('ENDORSE_SETTLEMENT_REPORT', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.ENDORSING_SETTLEMENT_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let eSignature = [];
      if (
        payload &&
        payload.e_signature &&
        urls &&
        urls.e_signature &&
        payload.e_signature.length === urls.e_signature.length
      ) {
        const dataFile = payload.e_signature;
        dataFile.forEach(file => {
          if (urls.e_signature.some(str => str.includes(file.name))) {
            let getURL = urls.e_signature.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              eSignature.push(currentObj);
            }
          }
        });

        yield delay(urls.e_signature.length * 1000);
      }

      const apiResult = yield endorseSettlementReportAPI(
        { ...payload, e_signature: eSignature },
        roleHeaderAuth
      );

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ENDORSE_SETTLEMENT_REPORT_SUCCESS,
          loading: false,
          message: result.message
        });

        // yield commonFetchRequests(payload.merchant_id);
        yield put({
          type: settlementActions.FETCH_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID,
          payload: payload.merchant_settlement_cycle_id
        });
        yield put({
          type: settlementActions.FETCH_SETTLEMENT_REPORT_HISTORY,
          payload: payload.merchant_settlement_cycle_id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        yield put({
          type: actions.ENDORSE_SETTLEMENT_REPORT_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.ENDORSE_SETTLEMENT_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* rejectSettlementReport() {
  yield takeEvery('REJECT_SETTLEMENT_REPORT', function* ({ payload }) {
    try {
      yield put({
        type: actions.REJECTING_SETTLEMENT_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield rejectSettlementReportAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REJECT_SETTLEMENT_REPORT_SUCCESS,
          loading: false,
          message: result.message
        });

        // yield commonFetchRequests(payload.merchant_id);
        yield put({
          type: settlementActions.FETCH_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID,
          payload: payload.merchant_settlement_cycle_id
        });
        yield put({
          type: settlementActions.FETCH_SETTLEMENT_REPORT_HISTORY,
          payload: payload.merchant_settlement_cycle_id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        yield put({
          type: actions.REJECT_SETTLEMENT_REPORT_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.REJECT_SETTLEMENT_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* generateSettlementReport() {
  yield takeEvery('GENERATE_SETTLEMENT_REPORT', function* ({ payload }) {
    try {
      yield put({
        type: actions.GENERATING_SETTLEMENT_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateSettlementReportAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.GENERATE_SETTLEMENT_REPORT_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: settlementActions.FETCH_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID,
          payload: payload.merchant_settlement_cycle_id
        });
        yield put({
          type: settlementActions.FETCH_SETTLEMENT_REPORT_HISTORY,
          payload: payload.merchant_settlement_cycle_id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.GENERATE_SETTLEMENT_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.GENERATE_SETTLEMENT_REPORT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_SETTLEMENT_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateRiskLevel() {
  yield takeEvery('UPDATE_MIS_RISK_LEVEL', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.UPDATING_MIS_RISK_LEVEL,
        loading: true
      });

      let finalDataForUpload = [];
      if (payload && payload.files && payload.files.length === urls.length) {
        const dataFile = payload.files;
        dataFile.forEach(file => {
          if (urls.some(str => str.includes(file.name))) {
            let getURL = urls.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              finalDataForUpload.push(currentObj);
            }
          }
        });

        yield delay(urls.length * 1000);
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateRiskLevelAPI(
        { ...payload, risk_scoring_file: finalDataForUpload },
        roleHeaderAuth
      );

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.UPDATE_MIS_RISK_LEVEL_SUCCESS,
          loading: false,
          message: result.message
        });

        yield commonFetchRequests(payload.merchant_mgmt_id);
      } else {
        yield put({
          type: actions.UPDATE_MIS_RISK_LEVEL_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_MIS_RISK_LEVEL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* allowPartialOnboarding() {
  yield takeEvery('UPDATE_PARTIAL_ONBOARDING_ALLOWED', function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_PARTIAL_ONBOARDING_ALLOWED,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield allowPartialOnboardingAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.UPDATE_PARTIAL_ONBOARDING_ALLOWED_SUCCESS,
          loading: false,
          message: result.message
        });

        yield commonFetchRequests(payload.merchant_management_id);
      } else {
        yield put({
          type: actions.UPDATE_PARTIAL_ONBOARDING_ALLOWED_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_PARTIAL_ONBOARDING_ALLOWED_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* getS3UrlsKaiserCheckResults() {
  yield takeEvery('STORE_KAISER_CHECK_RESULTS_FOR_UPLOAD', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_KAISER_CHECK_RESULTS_FOR_UPLOAD,
        loading: true
      });
      const state = yield select();
      const presignedUrlsKaiserCheckResults = state.Onboarding.presignedUrlsKaiserCheckResults;

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getURLsForFilesAPI(key, files, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (presignedUrlsKaiserCheckResults && presignedUrlsKaiserCheckResults.length > 0) {
          urlsArr.push(...presignedUrlsKaiserCheckResults);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_KAISER_CHECK_RESULTS_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_KAISER_CHECK_RESULTS_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_KAISER_CHECK_RESULTS_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* manageKaiserCheckResultsFiles() {
  yield takeEvery('MANAGE_KAISER_CHECK_RESULTS_FILES', function* ({ urls, payload, id }) {
    try {
      yield put({
        type: actions.MANAGING_KAISER_CHECK_RESULTS_FILES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let kaiserCheckResultsData = [];
      if (
        payload &&
        payload.kaiser_check_results_files &&
        payload.kaiser_check_results_files.length === urls.kaiser_check_results_files.length
      ) {
        const dataFile = payload.kaiser_check_results_files;
        dataFile.forEach(file => {
          if (urls.kaiser_check_results_files.some(str => str.includes(file.name))) {
            let getURL = urls.kaiser_check_results_files.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              kaiserCheckResultsData.push(currentObj);
            }
          }
        });

        yield delay(urls.kaiser_check_results_files.length * 1000);
      }

      const apiResult = yield manageKaiserCheckResultsFilesAPI(
        {
          ...payload,
          kaiser_check_results_files: kaiserCheckResultsData
        },
        id,
        roleHeaderAuth
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.MANAGE_KAISER_CHECK_RESULTS_FILES_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_MERCHANT_KAISER_CHECK_RESULTS_BY_ID,
          payload: { id: payload.merchant_management_id }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.MANAGE_KAISER_CHECK_RESULTS_FILES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.MANAGE_KAISER_CHECK_RESULTS_FILES_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.MANAGE_KAISER_CHECK_RESULTS_FILES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* getS3UrlsForRiskScoringFile() {
  yield takeEvery('STORE_RISK_SCORING_FILE_FOR_UPLOAD', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_RISK_SCORING_FILE_FOR_UPLOAD,
        loading: true
      });
      const state = yield select();
      const presignedUrlsForRiskScoringFile = state.Onboarding.presignedUrlsForRiskScoringFile;

      const roleHeaderAuth = null;
      const apiResult = yield fetchURLsForMerchantFilesWithKeyAPI(key, files, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (presignedUrlsForRiskScoringFile && presignedUrlsForRiskScoringFile.length > 0) {
          urlsArr.push(...presignedUrlsForRiskScoringFile);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_RISK_SCORING_FILE_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_RISK_SCORING_FILE_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_RISK_SCORING_FILE_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* downloadRiskAssessmentFile() {
  yield takeEvery('DOWNLOAD_RISK_ASSESSMENT_DOCUMENT', function* ({ id, payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_RISK_ASSESSMENT_DOCUMENT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadRiskAssessmentFileAPI(id, payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_RISK_ASSESSMENT_DOCUMENT_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }

        yield commonFetchRequests(payload);
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_RISK_ASSESSMENT_DOCUMENT_FAILED,
            message: `Endpoint not found`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_RISK_ASSESSMENT_DOCUMENT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_RISK_ASSESSMENT_DOCUMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* approveKYBPassed() {
  yield takeEvery('APPROVE_KYB_PASSED', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.APPROVING_KYB_PASSED,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield approveKYBPassedAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.APPROVE_KYB_PASSED_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_ALL_MERCHANT_PORTAL,
          payload: {
            page: 0,
            limit: 20
          },
          currentList: null
        });
        // yield commonFetchRequests(id);
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.APPROVE_KYB_PASSED_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.APPROVE_KYB_PASSED_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REJECT_VAT_EXEMPTION_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchOnboardingMerchants() {
  yield takeEvery('FETCH_ONBOARDING_MERCHANTS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_ONBOARDING_MERCHANTS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantOnboardingStatusesAPI(
        payload,
        roleHeaderAuth
      );

      const result = apiResult.data;

      const onboardingMerchants = result?.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ONBOARDING_MERCHANTS_SUCCESS,
          loading: false,
          result: result && onboardingMerchants ? onboardingMerchants : [],
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_ONBOARDING_MERCHANTS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ONBOARDING_MERCHANTS_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchMerchantOnboardingStatuses() {
  yield takeEvery('FETCH_MERCHANT_ONBOARDING_STATUSES', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_ONBOARDING_STATUSES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantOnboardingStatusesAPI(
        {
          ...payload
        },
        roleHeaderAuth
      );

      const result = apiResult.data;

      const merchantOnboardingStatuses = result?.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_ONBOARDING_STATUSES_SUCCESS,
          loading: false,
          result: result && merchantOnboardingStatuses ? merchantOnboardingStatuses : [],
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_ONBOARDING_STATUSES_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_ONBOARDING_STATUSES_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchUserOnboardingActivity() {
  yield takeEvery('FETCH_USER_ONBOARDING_LOGS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_USER_ONBOARDING_LOGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchUserOnboardingActivityAPI(
        payload,
        roleHeaderAuth
      );

      const result = apiResult.data;

      const logs = result?.data;
      const newLogs = logs?.map(log => {
        const value = typeof log.value === 'string' ? log.value : JSON.stringify(log.value);
        return { ...log, value };
      });

      if (result.success) {
        yield put({
          type: actions.FETCH_USER_ONBOARDING_LOGS_SUCCESS,
          loading: false,
          result: result && newLogs ? newLogs : [],
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_USER_ONBOARDING_LOGS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_USER_ONBOARDING_LOGS_FAILED,
        loading: false
      });
    }
  });
}

export function* approveConstellationMerchantApplication() {
  yield takeEvery(actions.APPROVE_CONSTELLATION_MERCHANT_APPLICATION, function* ({ payload }) {
    try {
      yield put({
        type: actions.APPROVING_CONSTELLATION_MERCHANT_APPLICATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield approveConstellationMerchantApplicationAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.APPROVE_CONSTELLATION_MERCHANT_APPLICATION_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_ALL_MERCHANT_PORTAL,
          payload: {
            page: 0,
            limit: 20
          },
          currentList: null
        });
        // yield commonFetchRequests(id);
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.APPROVE_CONSTELLATION_MERCHANT_APPLICATION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.APPROVE_CONSTELLATION_MERCHANT_APPLICATION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.APPROVE_CONSTELLATION_MERCHANT_APPLICATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* rejectConstellationMerchantApplication() {
  yield takeEvery(actions.REJECT_CONSTELLATION_MERCHANT_APPLICATION, function* ({ payload }) {
    try {
      yield put({
        type: actions.REJECTING_CONSTELLATION_MERCHANT_APPLICATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield rejectConstellationMerchantApplicationAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.REJECT_CONSTELLATION_MERCHANT_APPLICATION_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_ALL_MERCHANT_PORTAL,
          payload: {
            page: 0,
            limit: 20
          },
          currentList: null
        });
        // yield commonFetchRequests(id);
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REJECT_CONSTELLATION_MERCHANT_APPLICATION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REJECT_CONSTELLATION_MERCHANT_APPLICATION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REJECT_CONSTELLATION_MERCHANT_APPLICATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* rejectMerchantApplication() {
  yield takeEvery('REJECT_MERCHANT_APPLICATION', function* ({ payload }) {
    try {
      yield put({
        type: actions.REJECTING_MERCHANT_APPLICATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield rejectMerchantApplicationAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.REJECT_MERCHANT_APPLICATION_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_ALL_MERCHANT_PORTAL,
          payload: {
            page: 0,
            limit: 20
          },
          currentList: null
        });
        // yield commonFetchRequests(id);
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REJECT_MERCHANT_APPLICATION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REJECT_MERCHANT_APPLICATION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REJECT_MERCHANT_APPLICATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* endorseMOApplication() {
  yield takeEvery('ENDORSE_MO_APPLICATION', function* ({ payload }) {
    try {
      yield put({
        type: actions.ENDORSING_MO_APPLICATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield endorseMOApplicationAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ENDORSE_MO_APPLICATION_SUCCESS,
          loading: false,
          message: result.message
        });

        yield commonFetchRequests(payload.merchant_mgmt_id);
      } else {
        yield put({
          type: actions.ENDORSE_MO_APPLICATION_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.ENDORSE_MO_APPLICATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* requestForApprovalMOApplication() {
  yield takeEvery('REQUEST_APPROVAL_MO_APPLICATION', function* ({ payload }) {
    try {
      yield put({
        type: actions.REQUESTING_APPROVAL_MO_APPLICATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield requestForApprovalMOApplicationAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REQUEST_APPROVAL_MO_APPLICATION_SUCCESS,
          loading: false,
          message: result.message
        });

        yield commonFetchRequests(payload.merchant_mgmt_id);
      } else {
        yield put({
          type: actions.REQUEST_APPROVAL_MO_APPLICATION_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.REQUEST_APPROVAL_MO_APPLICATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* rejectMOApplication() {
  yield takeEvery('REJECT_MO_APPLICATION', function* ({ payload }) {
    try {
      yield put({
        type: actions.REJECTING_MO_APPLICATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield rejectMOApplicationAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REJECT_MO_APPLICATION_SUCCESS,
          loading: false,
          message: result.message
        });

        yield commonFetchRequests(payload.merchant_mgmt_id);
      } else {
        yield put({
          type: actions.REJECT_MO_APPLICATION_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.REJECT_MO_APPLICATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* approveMOApplication() {
  yield takeEvery('APPROVE_MO_APPLICATION', function* ({ payload }) {
    try {
      yield put({
        type: actions.APPROVING_MO_APPLICATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield approveMOApplicationAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.APPROVE_MO_APPLICATION_SUCCESS,
          loading: false,
          message: result.message
        });

        yield commonFetchRequests(payload.merchant_mgmt_id);
      } else {
        yield put({
          type: actions.APPROVE_MO_APPLICATION_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.APPROVE_MO_APPLICATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchTestAccessExemptionRequests() {
  yield takeEvery('FETCH_TEST_ACCESS_EXEMPTION_REQUESTS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_TEST_ACCESS_EXEMPTION_REQUESTS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchTestAccessExemptionRequestsAPI(
        payload, roleHeaderAuth
      );

      const result = apiResult.data;

      const testAccessExemptionRequests = result?.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_TEST_ACCESS_EXEMPTION_REQUESTS_SUCCESS,
          loading: false,
          result: result && testAccessExemptionRequests ? testAccessExemptionRequests : [],
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_TEST_ACCESS_EXEMPTION_REQUESTS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_TEST_ACCESS_EXEMPTION_REQUESTS_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchTestAccessExemptionRequestDetails() {
  yield takeEvery('FETCH_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchTestAccessExemptionRequestDetailsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      const testAccessExemptionRequestDetails = result?.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS_SUCCESS,
          loading: false,
          result:
            result && testAccessExemptionRequestDetails ? testAccessExemptionRequestDetails : {},
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchExemptionRequestLogs() {
  yield takeEvery('FETCH_EXEMPTION_REQUEST_LOGS', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_EXEMPTION_REQUEST_LOGS
        });
      } else {
        yield put({
          type: actions.FETCHING_EXEMPTION_REQUEST_LOGS,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchExemptionRequestLogsAPI(payload, pagination, roleHeaderAuth);
      const currentList = pagination.currentData && loadmore ? pagination.currentData : [];

      const result = apiResult.data;

      const parseData =
        currentList && currentList.length > 0
          ? currentList.concat(result.data.logs)
          : result.data.logs;

      const finalData =
        parseData && parseData.length > 0
          ? parseData.sort((a, b) => {
              const dateA = new Date(a.created_at);
              const dateB = new Date(b.created_at);
              return dateB - dateA;
            })
          : [];

      if (result.success) {
        yield put({
          type: actions.FETCH_EXEMPTION_REQUEST_LOGS_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.data.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_EXEMPTION_REQUEST_LOGS_FAILED,
          loading: false,
          result: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_EXEMPTION_REQUEST_LOGS_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}

export function* downloadExemptionRequestFile() {
  yield takeEvery(
    'DOWNLOAD_EXEMPTION_REQUEST_FILE',
    function* ({ attachmentId, exemptionRequestId }) {
      try {
        yield put({
          type: actions.DOWNLOADING_EXEMPTION_REQUEST_FILE,
          loading: true
        });
        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield downloadExemptionRequestFileAPI(
          attachmentId,
          exemptionRequestId,
          roleHeaderAuth
        );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.FETCH_EXEMPTION_REQUEST_LOGS,
            payload: exemptionRequestId,
            pagination: { page: 0, limit: 20 }
          });
          yield put({
            type: actions.DOWNLOAD_EXEMPTION_REQUEST_FILE_SUCCESS,
            loading: false,
            message: 'Attachment downloaded successfully.'
          });
          if (result.url) {
            window.open(result.url, '_blank');
          }
        } else {
          if (result.status === 404) {
            yield put({
              type: actions.DOWNLOAD_EXEMPTION_REQUEST_FILE_FAILED,
              message: `Endpoint not found`,
              loading: false
            });
          } else {
            yield put({
              type: actions.DOWNLOAD_EXEMPTION_REQUEST_FILE_FAILED,
              message: result.message,
              loading: false
            });
          }
        }
      } catch (error) {
        yield put({
          type: actions.DOWNLOAD_EXEMPTION_REQUEST_FILE_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    }
  );
}

export function* reviewExemptionRequest() {
  yield takeEvery('REVIEW_EXEMPTION_REQUEST', function* ({ payload }) {
    try {
      yield put({
        type: actions.REVIEWING_EXEMPTION_REQUEST,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield reviewExemptionRequestAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      yield exemptionPageCommonFetchRequests(payload.exemption_request_id);

      if (result.success) {
        yield put({
          type: actions.REVIEW_EXEMPTION_REQUEST_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        yield put({
          type: actions.REVIEW_EXEMPTION_REQUEST_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.REVIEW_EXEMPTION_REQUEST_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* endorseExemptionRequest() {
  yield takeEvery('ENDORSE_EXEMPTION_REQUEST', function* ({ payload }) {
    try {
      yield put({
        type: actions.ENDORSING_EXEMPTION_REQUEST,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield endorseExemptionRequestAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      yield exemptionPageCommonFetchRequests(payload.exemption_request_id);

      if (result.success) {
        yield put({
          type: actions.ENDORSE_EXEMPTION_REQUEST_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        yield put({
          type: actions.ENDORSE_EXEMPTION_REQUEST_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.ENDORSE_EXEMPTION_REQUEST_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* approveExemptionRequest() {
  yield takeEvery('APPROVE_EXEMPTION_REQUEST', function* ({ payload }) {
    try {
      yield put({
        type: actions.APPROVING_EXEMPTION_REQUEST,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield approveExemptionRequestAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      yield exemptionPageCommonFetchRequests(payload.exemption_request_id);

      if (result.success) {
        yield put({
          type: actions.APPROVE_EXEMPTION_REQUEST_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        yield put({
          type: actions.APPROVE_EXEMPTION_REQUEST_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.APPROVE_EXEMPTION_REQUEST_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* rejectExemptionRequest() {
  yield takeEvery('REJECT_EXEMPTION_REQUEST', function* ({ payload }) {
    try {
      yield put({
        type: actions.REJECTING_EXEMPTION_REQUEST,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield rejectExemptionRequestAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      yield exemptionPageCommonFetchRequests(payload.exemption_request_id);

      if (result.success) {
        yield put({
          type: actions.REJECT_EXEMPTION_REQUEST_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        yield put({
          type: actions.REJECT_EXEMPTION_REQUEST_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.REJECT_EXEMPTION_REQUEST_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

function* commonFetchRequests(payload) {
  yield put({
    type: actions.FETCH_MERCHANT_PORTAL_BY_ID,
    payload
  });
  yield put({
    type: accountOfficerAction.FETCH_MIS_DATA_BY_ID,
    payload
  });
  yield put({
    type: actions.FETCH_MERCHANT_ONBOARDING_LOGS,
    payload,
    pagination: {
      page: 0,
      limit: 20
    }
  });
}

function* exemptionPageCommonFetchRequests(payload) {
  yield put({
    type: actions.FETCH_TEST_ACCESS_EXEMPTION_REQUESTS,
    payload: {},
    pagination: { page: 0, limit: 20 }
  });

  yield put({
    type: actions.FETCH_TEST_ACCESS_EXEMPTION_REQUEST_DETAILS,
    payload
  });

  yield put({
    type: actions.FETCH_EXEMPTION_REQUEST_LOGS,
    payload,
    pagination: { page: 0, limit: 20 }
  });
}

export function* fetchTOSRequests() {
  yield takeEvery(actions.FETCH_TOS_REQUESTS, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_TOS_REQUESTS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchTOSRequestsAPI(
        payload,
        roleHeaderAuth
      );

      const result = apiResult.data;

      const tosRequests = result?.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_TOS_REQUESTS_SUCCESS,
          loading: false,
          result: result && tosRequests ? tosRequests : [],
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_TOS_REQUESTS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_TOS_REQUESTS_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchTOSRequestsSummary() {
  yield takeEvery(actions.FETCH_TOS_REQUESTS_SUMMARY, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_TOS_REQUESTS_SUMMARY,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchTOSRequestsSummaryAPI(
        {
          ...payload
        },
        roleHeaderAuth
      );

      const result = apiResult.data;

      const tosRequestsSummary = result?.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_TOS_REQUESTS_SUMMARY_SUCCESS,
          loading: false,
          result: result && tosRequestsSummary ? tosRequestsSummary : [],
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_TOS_REQUESTS_SUMMARY_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_TOS_REQUESTS_SUMMARY_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchTOSRequestsSpecialistProductivity() {
  yield takeEvery(actions.FETCH_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchTOSRequestsSpecialistProductivityAPI(
        {
          ...payload
        },
        roleHeaderAuth
      );

      const result = apiResult.data;

      const tosRequestsSummary = result?.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY_SUCCESS,
          loading: false,
          result: result && tosRequestsSummary ? tosRequestsSummary : [],
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_TOS_REQUESTS_SPECIALIST_PRODUCTIVITY_FAILED,
        loading: false
      });
    }
  });
}

export function* generateTOSProductivityReport() {
  yield takeEvery(actions.GENERATE_TOS_PRODUCTIVITY_REPORT, function* ({ payload }) {
    try {
      yield put({
        type: actions.GENERATING_TOS_PRODUCTIVITY_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateTOSProductivityReportAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.GENERATE_TOS_PRODUCTIVITY_REPORT_SUCCESS,
          loading: false,
          message: result.message,
          result: result.data
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.GENERATE_TOS_PRODUCTIVITY_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.GENERATE_TOS_PRODUCTIVITY_REPORT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_TOS_PRODUCTIVITY_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadTOSProductivityReport() {
  yield takeEvery(actions.DOWNLOAD_TOS_PRODUCTIVITY_REPORT, function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_TOS_PRODUCTIVITY_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadTOSProductivityReportAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_TOS_PRODUCTIVITY_REPORT_SUCCESS,
          loading: false,
          message: 'Report downloaded successfully.'
        });

        if (result.url) {
          window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_TOS_PRODUCTIVITY_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_TOS_PRODUCTIVITY_REPORT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_TOS_PRODUCTIVITY_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllTOSProductivityReportData() {
  yield takeEvery(
    actions.FETCH_ALL_TOS_PRODUCTIVITY_REPORT_DATA,
    function* ({ payload }) {
      try {
        yield put({
          type: actions.FETCHING_ALL_TOS_PRODUCTIVITY_REPORT_DATA,
          loading: true
        });
        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield fetchAllTOSProductivityReportDataAPI(
          payload,
          roleHeaderAuth
        );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.FETCH_ALL_TOS_PRODUCTIVITY_REPORT_DATA_SUCCESS,
            loading: false,
            result: result ? result.data : null,
            pagination: result ? result.pagination : null
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_TOS_PRODUCTIVITY_REPORT_DATA_FAILED,
            loading: false
          });
        }
      } catch (error) {
        yield put({
          type: actions.FETCH_ALL_TOS_PRODUCTIVITY_REPORT_DATA_FAILED,
          loading: false
        });
      }
    }
  );
}

function* getRoleHeader() {
  const state = yield select();
  const identity = state.Auth.identity;
  const currentPage = state.App.currentPage;
  const currentAction = state.App.currentAction;
  if (currentAction) {
    return `${identity.role_id}:${currentPage.id}:${currentAction.id}`;
  } else {
    return `${identity.role_id}:${currentPage.id}`;
  }
}
async function uploadFileToS3(url, payload) {
  return await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': payload.file.type
    },
    body: payload.file
  });
}

async function uploadFileToS3WithPromise(url, payload) {
  return await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': payload.file.type
    },
    body: payload.file
  }).then(res => {
    if (!res.ok) {
      throw new Error(
        `Couldn't upload files. Check your connection, refresh the page, and try again.`
      );
    }
    return res;
  });
}

function fetchAllMerchantPortalAPI(data, roleAuth) {
  return post(`merchant-portals`, data, null, null, roleAuth);
}
function fetchMerchantKYBDocumentsAPI(data, roleAuth) {
  return post(`merchant-portals/kyb_documents`, data, null, null, roleAuth);
}

function fetchMerchantKaiserCheckResultsAPI(data, roleAuth) {
  return post(`uploaded-kaiser-check-results/fetch-by-id`, data, null, null, roleAuth);
}

function generateMerchantOnboardingStatusReportAPI(data, roleAuth) {
  return post(`generate-merchant-onboarding-status-report`, data, null, roleAuth);
}

function downloadMerchantOnboardingSettlementReportAPI(id, roleAuth) {
  return get(
    `download-merchant-onboarding-settlement-report/${id}`,
    null,
    null,
    null,
    null,
    roleAuth
  );
}

function fetchAllMerchantOnboardingStatusReportDataAPI(data, roleAuth) {
  return post(`get-all/merchant-onboarding-status-reports`, data, null, roleAuth);
}

function fetchAmendHistoryMOCAPI(data, roleAuth) {
  return post(`uploaded-kyb-files/fetch-kyb-by-ids`, data, null, null, roleAuth);
}
function downloadKYBDocumentAPI(id, payload, roleAuth) {
  return get(
    `download-kyb-document/merchant-portals/${id}/${payload}`,
    null,
    null,
    null,
    null,
    roleAuth
  );
}

function downloadKaiserCheckResultsAPI(id, payload, roleAuth) {
  return get(
    `uploaded-kaiser-check-results/${id}/${payload}/download-kaiser-check-results`,
    null,
    null,
    null,
    null,
    roleAuth
  );
}

function downloadSettlementDocumentAPI(id, payload, roleAuth) {
  return get(`download-settlement-report/${payload}/${id}`, null, null, null, null, roleAuth);
}
function downloadAddendumDocumentAPI(id, payload, roleAuth) {
  return get(`download-addendum/${payload}/${id}`, null, null, null, null, roleAuth);
}
function merchantDownloadKYBDocumentAPI(id) {
  return get(`kyb-documents/${id}`, null, null, null, null, null);
}
function changeDocumentStatusAPI(data, id) {
  return PUT(`update-document/merchant-portals/kyb-document/${id}`, data);
}
function fetchMerchantPortalByIDAPI(id, roleAuth) {
  return get(`merchant-portals/${id}`, null, null, null, null, roleAuth);
}
function generateKYBFormAPI(id, data, roleAuth) {
  return post(`merchant/${id}/generate-kyb-form`, data, null, null, roleAuth);
}
function resendKYBFormAPI(data, roleAuth) {
  return post(`kyb-forms/resend`, data, null, null, roleAuth);
}
function regenerateKYBFormAPI(data, roleAuth) {
  return post(`merchant/regenerate-kyb-form`, data, null, null, roleAuth);
}
function fetchAllGenratedKYBFormsAPI(data, roleAuth) {
  return post(`generated-kyb-forms`, data, null, roleAuth);
}

function getURLForFileAPI(key, bucketKey) {
  return get(
    `get/utility/presigned-s3-url-with-key/kyb-link/${bucketKey}/${key}`,
    null,
    null,
    null,
    null,
    null
  );
}

function getURLsForMerchantFilesAPI(data, roleAuth) {
  return post(`post/utility/multiple-presigned-s3-url-with-key`, data, null, null, roleAuth);
}
function getURLsForFilesAPI(key, data, roleAuth) {
  return post(`get/utility/multiple-presigned-s3-url-with-key/${key}`, data, null, null, roleAuth);
}
function uploadVATExemptionFilesAPI(data, id, roleAuth) {
  return PUT(`merchant/${id}/submit-vat-exemption-form`, data, null, roleAuth);
}
function uploadKYBFilesAPI(data, id, roleAuth) {
  return PUT(`merchant/${id}/submit-kyb-form`, data, null, roleAuth);
}
function uploadKYBLinkFilesAPI(data, id, roleAuth) {
  return PUT(`merchant/${id}/submit-kyb-link`, data, null, roleAuth);
}
function uploadKYBFilesByMOAPI(data, roleAuth) {
  return post(`uploaded-kyb-files`, data, null, roleAuth);
}
function fetchKYBFormMerchantDataAPI(id) {
  return get(`merchant/${id}/kyb-form`, null, null, null, null, null);
}
function fetchMerchantOnboardingLogsAPI(data, pagination, roleAuth) {
  return get(
    `get/merchant-onboarding-logs/${data}`,
    pagination ? pagination : { page: 0, limit: 20 },
    null, 
    null,
    null,
    roleAuth
  );
}
function fetchMerchantSettlementLogsAPI(data, pagination, roleAuth) {
  return get(
    `get/finance-settlement-logs/${data}`,
    pagination ? pagination : { page: 0, limit: 20 },
    null,
    null,
    null,
    roleAuth
  );
}
function fetchAllOnboardingUsersAPI(roleAuth) {
  return post(`fetch/merchant-onboarding-users`, null, null, null, roleAuth);
}
function assignMerchantOnboardingAPI(data, roleAuth) {
  return post(`assign/merchant-portal/onboarding`, data, null, null, roleAuth);
}
function fetchAccountHistoryAPI(data, pagination, roleAuth) {
  return get(
    `merchant-portals/${data}/account-history`,
    pagination ? pagination : { page: 0, limit: 20 },
    null,
    null,
    null,
    roleAuth
  );
}
function fetchReportHistoryAPI(data, pagination, roleAuth) {
  return get(
    `get/finance-settlement-account-history/${data}`,
    pagination ? pagination : { page: 0, limit: 20 },
    null,
    null,
    null,
    roleAuth
  );
}
function fetchOnboardingLogsAPI(merchantManagementId, pagination, roleAuth) {
  return get(
    `merchant-portals/${merchantManagementId}/onboarding-logs`,
    pagination ? pagination : { page: 0, limit: 20 },
    null,
    null,
    null,
    roleAuth
  );
}
function requestMISAmendmentAPI(data, roleAuth) {
  return post(`request/mis-amendment`, data, null, null, roleAuth);
}
function approveMISAmendmentAPI(data, roleAuth) {
  return post(`approve/mis-amendment`, data, null, null, roleAuth);
}
function endorseMISAmendmentAPI(data, roleAuth) {
  return post(`endorse/mis-amendment`, data, null, null, roleAuth);
}
function rejectMISAmendmentAPI(data, roleAuth) {
  return post(`reject/mis-amendment`, data, null, null, roleAuth);
}
function reviewSettlementReportAPI(data, roleAuth) {
  return post(`review/finance-settlement-report`, data, null, null, roleAuth);
}
function approveSettlementReportAPI(data, roleAuth) {
  return post(`approve/finance-settlement-report`, data, null, null, roleAuth);
}
function endorseSettlementReportAPI(data, roleAuth) {
  return post(`endorse/finance-settlement-report`, data, null, null, roleAuth);
}
function rejectSettlementReportAPI(data, roleAuth) {
  return post(`reject/finance-settlement-report`, data, null, null, roleAuth);
}

function generateSettlementReportAPI(data, roleAuth) {
  return post(`generate/finance-settlement-report`, data, null, roleAuth);
}

function updateRiskLevelAPI(data, roleAuth) {
  return post(`update/mis-risk-level`, data, null, null, roleAuth);
}

function allowPartialOnboardingAPI(data, roleAuth) {
  return post(`update/allow-partial-onboarding`, data, null, null, roleAuth);
}

function manageKaiserCheckResultsFilesAPI(data, id, roleAuth) {
  return PUT(`manage-kaiser-check-results/merchant-portal/${id}`, data, null, roleAuth);
}
function fetchURLsForMerchantFilesWithKeyAPI(key, data, roleAuth) {
  return post(`get/utility/multiple-presigned-s3-url-with-key/${key}`, data, null, null, roleAuth);
}
function downloadRiskAssessmentFileAPI(id, payload, roleAuth) {
  return get(
    `download-risk-assessment-document/merchant-portals/${id}/${payload}`,
    null,
    null,
    null,
    null,
    roleAuth
  );
}

function approveKYBPassedAPI(data, id, roleAuth) {
  return PUT(`merchant-management/${id}/approve-kyb-passed`, data, null, roleAuth);
}

function fetchMerchantOnboardingStatusesAPI(data, roleAuth) {
  return post(`get-all/merchant-onboarding-statuses`, data, null, null, null, roleAuth);
}

function fetchUserOnboardingActivityAPI(payload, roleAuth) {
  return post(`get-all/merchant-onboarding-logs`, payload, null, null, null, roleAuth);
}

function approveConstellationMerchantApplicationAPI(data, roleAuth) {
  return PUT(
    `merchant-management/approve-constellation-merchant-application`,
    data,
    null,
    roleAuth
  );
}

function rejectConstellationMerchantApplicationAPI(data, roleAuth) {
  return PUT(`merchant-management/reject-constellation-merchant-application`, data, null, roleAuth);
}

function rejectMerchantApplicationAPI(data, roleAuth) {
  return PUT(`merchant-management/reject-merchant-application`, data, null, roleAuth);
}

function endorseMOApplicationAPI(data, roleAuth) {
  return post(`endorse/mo-application`, data, null, null, roleAuth);
}
function requestForApprovalMOApplicationAPI(data, roleAuth) {
  return post(`request/mo-application`, data, null, null, roleAuth);
}
function rejectMOApplicationAPI(data, roleAuth) {
  return post(`reject/mo-application`, data, null, null, roleAuth);
}
function approveMOApplicationAPI(data, roleAuth) {
  return post(`approve/mo-application`, data, null, null, roleAuth);
}

function fetchTestAccessExemptionRequestsAPI(payload, roleAuth) {
  return post(
    `get-all/merchant-onboarding-test-access-exemptions-requests`,
    payload,
    null,
    null,
    null,
    roleAuth
  );
}

function fetchTestAccessExemptionRequestDetailsAPI(data, roleAuth) {
  return get(
    `get-by-id/merchant-onboarding-test-access-exemptions-request-details/${data}`,
    null,
    null,
    null,
    null,
    roleAuth
  );
}

function fetchExemptionRequestLogsAPI(data, pagination, roleAuth) {
  return get(
    `get/exemption-request-logs/${data}`,
    pagination ? pagination : { page: 0, limit: 20 },
    null,
    null,
    null,
    roleAuth
  );
}

function downloadExemptionRequestFileAPI(id, payload, roleAuth) {
  return get(`download-exemption-request-file/${id}/${payload}`, null, null, null, null, roleAuth);
}

function reviewExemptionRequestAPI(data, roleAuth) {
  return post(`review/exemption-request`, data, null, null, roleAuth);
}

function endorseExemptionRequestAPI(data, roleAuth) {
  return post(`endorse/exemption-request`, data, null, null, roleAuth);
}

function approveExemptionRequestAPI(data, roleAuth) {
  return post(`approve/exemption-request`, data, null, null, roleAuth);
}
function rejectExemptionRequestAPI(data, roleAuth) {
  return post(`reject/exemption-request`, data, null, null, roleAuth);
}

function fetchTOSRequestsAPI(payload, roleAuth) {
  return post(`get-all/tos-requests`, payload, null, null, null, roleAuth);
}

function fetchTOSRequestsSummaryAPI(data, roleAuth) {
  return post(`get/tos-requests-summary`, data, null, null, roleAuth);
}

function fetchTOSRequestsSpecialistProductivityAPI(data, roleAuth) {
  return post(`get/tos-requests-specialist-productivity`, data, null, null, roleAuth);
}

function generateTOSProductivityReportAPI(data, roleAuth) {
  return post(`generate-integration-request-form-report`, data, null, roleAuth);
}

function downloadTOSProductivityReportAPI(data, roleAuth) {
  return post(`download-integration-request-form-report`, data, null, roleAuth);
}

function fetchAllTOSProductivityReportDataAPI(data, roleAuth) {
  return post(
    `get-all/merchant-integration-request-form-reports`,
    data,
    null,
    null,
    roleAuth
  );
}

export default function* rootSaga() {
  yield all([
    fork(fetchAllMerchantPortal),
    fork(generateMerchantOnboardingStatusReport),
    fork(downloadMerchantOnboardingStatusReport),
    fork(fetchAllMerchantOnboardingStatusReportData),
    fork(fetchMerchantKYBDocuments),
    fork(downloadKYBDocument),
    fork(merchantDownloadKYBDocument),
    fork(changeDocumentStatus),
    fork(fetchMerchantPortalByID),
    fork(generateKYBForm),
    fork(fetchAllGeneratedKYBForms),
    fork(regenerateKYBForm),
    fork(getS3UrlsVATExemptionFile),
    fork(uploadVATExemptionFiles),
    fork(getS3UrlsSECFile),
    fork(getS3UrlsAOIFile),
    fork(getS3UrlsGISFile),
    fork(uploadKYBFiles),
    fork(uploadKYBFilesByMO),
    fork(fetchAmendHistoryMOC),
    fork(fetchKYBFormMerchantDetails),
    fork(fetchAccountHistory),
    fork(fetchOnboardingLogs),
    fork(fetchMerchantOnboardingLogs),
    fork(fetchAllOnboardingUsers),
    fork(assignMerchantOnboarding),
    fork(requestMISAmendment),
    fork(approveMISAmendment),
    fork(endorseMISAmendment),
    fork(rejectMISAmendment),
    fork(reviewSettlementReport),
    fork(approveSettlementReport),
    fork(endorseSettlementReport),
    fork(rejectSettlementReport),
    fork(fetchSettlementOnboardingLogs),
    fork(fetchReportHistory),
    fork(generateSettlementReport),
    fork(downloadSettlementDocument),
    fork(downloadAddendumDocument),
    fork(updateRiskLevel),
    fork(allowPartialOnboarding),
    fork(getS3UrlsForRiskScoringFile),
    fork(downloadRiskAssessmentFile),
    fork(getS3UrlsKaiserCheckResults),
    fork(manageKaiserCheckResultsFiles),
    fork(fetchMerchantKaiserCheckResults),
    fork(downloadKaiserCheckResults),
    fork(approveKYBPassed),
    fork(fetchMerchantOnboardingStatuses),
    fork(fetchMerchantOnboardingDashboardLogs),
    fork(fetchOnboardingMerchants),
    fork(fetchUserOnboardingActivity),
    fork(approveConstellationMerchantApplication),
    fork(rejectConstellationMerchantApplication),
    fork(rejectMerchantApplication),
    fork(endorseMOApplication),
    fork(requestForApprovalMOApplication),
    fork(rejectMOApplication),
    fork(approveMOApplication),
    fork(fetchTestAccessExemptionRequests),
    fork(fetchTestAccessExemptionRequestDetails),
    fork(fetchExemptionRequestLogs),
    fork(downloadExemptionRequestFile),
    fork(reviewExemptionRequest),
    fork(endorseExemptionRequest),
    fork(approveExemptionRequest),
    fork(rejectExemptionRequest),
    fork(fetchTOSRequests),
    fork(fetchTOSRequestsSummary),
    fork(fetchTOSRequestsSpecialistProductivity),
    fork(generateTOSProductivityReport),
    fork(downloadTOSProductivityReport),
    fork(fetchAllTOSProductivityReportData),
    fork(getS3UrlBIR2303File),
    fork(getS3UrlDTICertificateFile),
    fork(uploadKYBLinkFiles),
    fork(getS3UrlsForRequiredFiles),
    fork(resendKYBForm)
  ]);
}
